import { THint, TTagNoteKeys } from '@simlab/simlab-facility-management/common';
import {
  BehaviorSubject,
  catchError,
  EMPTY,
  forkJoin,
  from,
  map,
  Observable,
  of,
  take,
} from 'rxjs';
import { Vector3 } from 'three';
import { MpSdk, Renderer, Size } from '../../../assets/bundle/sdk';
import { ISceneState } from '../models/scene-state.interface';

export abstract class MatterportUtils {
  protected abstract _sdk: MpSdk | undefined;
  abstract state: ISceneState;
  protected hint: BehaviorSubject<THint | undefined> = new BehaviorSubject<
    THint | undefined
  >(undefined);

  takeEquirectangular() {
    if (!this._sdk) return EMPTY
    return from(this._sdk.Renderer.takeEquirectangular());
  }
  worldToScreen(
    position: Vector3,
    windowSize: Size
  ): Observable<Vector3 | undefined> {
    return this.state.positionChange$.pipe(
      take(1),
      map((pose => {
        if (pose && this._sdk) {
          
          const { x, y, z } = this._sdk.Conversion.worldToScreen(
            position,
            pose as unknown as MpSdk.Camera.Pose,
            windowSize
          );
          return new Vector3(x, y, z);
        } else {
          return undefined;
        }
      })
      )
    );
  }

  setHint(hint: THint) {
    this.hint.next(hint);
  }

  screenshot(
    resolution: Renderer.Resolution = {
      height: 800,
      width: 600,
    },
    visibility: Partial<Renderer.Visibility> = {
      mattertags: true,
      sweeps: false,
    }
  ): Observable<string | undefined> {
    if (this._sdk) {
      return from(this._sdk.Renderer.takeScreenShot(resolution, visibility));
    } else {
      return of(undefined);
    }
  }

  registerIcons$(icon_collection: Record<string, string>): Observable<void> {
    const icons = [];
    if (!this._sdk) return of(undefined);
    for (const key of Object.keys(icon_collection)) {
      icons.push(
        from(
          this._sdk.Asset.registerTexture(
            key,
            icon_collection[key as TTagNoteKeys]
          )
        )
      );
    }
    return forkJoin(icons).pipe(
      map(() => undefined),
      catchError((e) => {
        console.error(e);
        return of(e);
      })
    );
  }

  registerIcons(icon_collection: Record<string, string>): void {
    if (!this._sdk) return;
    for (const key of Object.keys(icon_collection)) {
      this._sdk.Asset.registerTexture(
        key,
        icon_collection[key as TTagNoteKeys]
      );
    }
  }
}
